'use strict';

function fSocialShare () {
    const socialShareButton = document.querySelector('.social-share');

    document.addEventListener('click', function(event) {
        if (event.target.closest('.social-share')) {
            socialShareButton.classList.toggle('is-active');
        } else {
            socialShareButton.classList.remove('is-active');
        }
    })
}